<app-tb-accordion
    *transloco="let tAdvancedOptions; read: 'advanced_options'"
    [title]="tAdvancedOptions('fields')"
    [description]="tAdvancedOptions('options_description', { conf: 'fields' })"
    [expanded]="true"
    [background]="true"
    [settingsShow]="true"
    (callAdvanced)="openFieldsSettings()"
>
    <div class="w-full flex bg-neutral2 px-4 pb-4">
        <div class="flex flex-col w-full gap-5 p-4 rounded-lg bg-white">
            @for (schema of availableTabs(); track schema.id) {
                @if (fieldsBySchema()[schema.id]; as fields) {
                    <div class="flex flex-row">
                        <div class="flex-1 body-2">
                            <div class="flex items-center gap-1">
                                <app-tb-icon [icon]="schema.icon!"></app-tb-icon>
                                <span>
                                    {{ schema.name }}
                                </span>
                            </div>
                        </div>
                        <div class="flex-1">
                            <app-field-section-content
                                [fields]="fields"
                                [inactiveFields]="inactiveFields()"
                            ></app-field-section-content>
                        </div>
                    </div>
                }
            }
        </div>
    </div>
</app-tb-accordion>
